import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: none;
`

export const IconBtn = styled.button`
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  flex: none;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.secondary};
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;

  svg {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    color: ${tokens.accent.base};
    border-color: ${tokens.accent.base};
    background: ${tokens.accent.soft};
  }
`

export const RoomList = styled.div`
  border-top: 1px solid ${tokens.border.hairline};
  padding: 0.625rem 1rem 0.875rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const RoomGroup = styled.div`
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  padding: 0.75rem 0.875rem;
`

export const RoomHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.625rem;
`

export const RoomTitle = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
  flex-wrap: wrap;
`

export const RoomName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const RoomContext = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const RoomCount = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.text.secondary};
  white-space: nowrap;
  flex: none;
`

export const BedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`

export const BedChip = styled.div<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.55rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  border-left: 2px solid ${(props) => props.$accent};
  font-size: ${tokens.font.micro};
`

export const BedChipDot = styled.span<{ $color: string }>`
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  flex: none;
  background: ${(props) => props.$color};
`

export const BedChipLabel = styled.span`
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const BedChipState = styled.span`
  color: ${tokens.text.muted};
`

export const RoomEmpty = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`
